import { useState, useEffect } from 'react';
import { Producto } from './Producto';
import { Link } from 'react-router-dom';
import { getProductos } from './CRUD/Mostrar';

export default function ProductosHome() {

    const [productos, setProductos] = useState([]);

    async function obtenerProductos() {
        const productos = await getProductos()
        setProductos(productos.slice(0, 4));
    }

    useEffect(() => {
        obtenerProductos();
    }, [])

    return (

        <>
            <section className="container-fluid px-0">
                <h2 className="productos-titulo text-light text-center py-5 fw-bold w-100">PRODUCTOS</h2>
                <div className="container">
                    <ul className='d-flex flex-wrap justify-content-center m-0 p-3'>
                        {
                            productos.map((producto) => (
                                <Producto info={producto} />
                            ))
                        }
                    </ul>
                    <div id="Prod" className='text-center py-3'>
                        <Link className='text-decoration-none' to='/productos'>
                            <button className="btn btn-primary w-50 producto-btn">Ver más</button>
                        </Link>
                    </div>
                </div>
            </section >
        </>
    )

}